import React, { useState, useMemo, useEffect } from 'react'
import { FormControl, InputLabel, MenuItem, Stack, Select } from '@mui/material';
import TestData from './TestData';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { api } from '/src/redux/api';
import ErrorModal from '../../../ItemProperties/Forms/FieldDataValidation/ErrorModal';

const Conversion = ({ okHandler, clear, setClear, selectedNode, updateLength }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { account } = useSelector((state) => state.queryParams);
  const [conversionList, setConversionList] = useState([]);
  const [conversion, setConversion] = useState('--Select--');
  const [testResult, setTestReult] = useState('');
  const [testData, setTestData] = useState('');
  const [errorModal, setErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (selectedNode?.ADVANCE && selectedNode?.ADVANCE?.FUNCTION) {
      setConversion(selectedNode.ADVANCE.FUNCTION);
      if (selectedNode.ADVANCE.FUNCTION !== '--Select--') {
        updateLength({ type: 'FUNCTION', len: 1 });
      }
    } else if (selectedNode?.FUNCTION) {
      setConversion(selectedNode.FUNCTION);
      if (selectedNode.FUNCTION !== '--Select--') {
        updateLength({ type: 'FUNCTION', len: 1 });
      }
    } else {
      setConversion('--Select--');
      updateLength({ type: 'FUNCTION', len: 0 });
    }
    getConversionList();
  }, [selectedNode?.key])

  const handleErrorModal = () => {
    setErrorModal(false);
    setErrorMessage('');
  }

  const testDataFromServer = () => {
    setLoading(true);
    dispatch(api.endpoints.testConversionData.initiate({
      account,
      data: testData,
      conversion_type: conversion
    },{forceRefetch: true})).then((res) => {
      if (res?.data?.current_state === 'SUCCESS') {
        setTestReult((res?.data?.message));
        setLoading(false);
      } else if (res?.data?.current_state === 'ERROR') {
        setErrorModal(true);
        setErrorMessage(res?.data?.message);
        setLoading(false);
      }
    })
  }

  const getTestData = (val) => {
    setTestData(val);
  }

  const recieveTestReqeust = (val) => {
    if (val) {
      testDataFromServer();
    }
  }

  const getConversionList = () => {
    dispatch(api.endpoints.getConversionList.initiate({
      account
    })).then((res) => {
      if (res?.data?.current_state === 'SUCCESS') {
        setConversionList(res?.data?.data);
      } else {
        setConversionList([]);
      }
    })
  }

  useEffect(() => {
    if (clear) {
      setClear(false);
    }
  }, [clear])

  return (
    <>
      <div className='padding-16'>
        <Stack spacing={"15px"} marginTop="15px">
          <FormControl variant='outlined' className='width-100' size='small'>
            <InputLabel> {t('LBL_CONVERSION')} </InputLabel>
            <Select
              className='width-100'
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 300,
                  },
                },
              }}
              name='CONVERSION'
              value={conversion}
              label={t('LBL_CONVERSION')}
              onChange={(e) => {
                const newValue = e.target.value;
                setConversion(newValue);
                if (newValue !== '--Select--' && newValue !== '') {
                  updateLength({ type: 'FUNCTION', len: 1 });
                } else {
                  updateLength({ type: 'FUNCTION', len: 0 });
                }
                okHandler({ type: 'FUNCTION', value: newValue === '--Select--' ? null : newValue });
                setTestReult('');
              }}>
              <MenuItem value="--Select--">--Select--</MenuItem>
              {conversionList?.map((obj, index) => (<MenuItem key={index} value={obj}>
                {obj}
              </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TestData testResult={testResult} getTestData={getTestData} sendTestRequest={recieveTestReqeust} type={''} isLoading={loading} />
        </Stack>
      </div>
      {errorModal && <ErrorModal
        errorModal={errorModal}
        handleErrorModal={handleErrorModal}
        errorMessage={errorMessage}></ErrorModal>}
    </>
  )
}

export default Conversion